/** Platform KB defaults (read-only reference — ADMIN-01 mockup). */
export const PLATFORM_ESTIMATION_DEFAULTS = {
  matrix: {
    XS: { OOTB: 4, Config: 8, Enhancement: 20, Custom: 32 },
    S: { OOTB: 8, Config: 16, Enhancement: 40, Custom: 64 },
    M: { OOTB: 16, Config: 32, Enhancement: 80, Custom: 128 },
    L: { OOTB: 32, Config: 64, Enhancement: 160, Custom: 256 },
    XL: { OOTB: 64, Config: 128, Enhancement: 320, Custom: 512 },
  },
  l4mult: 1.25,
  extrap: {
    design: 30,
    test: 35,
    migration: 20,
    cutover: 10,
    training: 18,
    pm: 15,
    hypercare: 10,
  },
  risk: {
    completeness: { min: 0.9, max: 1.4, default: 1.0 },
    experience: { min: 0.85, max: 1.25, default: 1.0 },
    complexity: { min: 0.9, max: 1.3, default: 1.0 },
    dataQuality: { min: 1.0, max: 1.3, default: 1.0 },
  },
  dayRate: 920,
  hrsPerDay: 8,
  contingency: 15,
};

export const SIZE_GUIDES = {
  XS: 'Single config option or simple process step',
  S: 'Straightforward process; standard capability with minor tailoring',
  M: 'Multi-step process; moderate config or custom work',
  L: 'Complex process; significant config or substantial development',
  XL: 'Highly complex; major custom dev or integration; significant risk',
};

export const EXTRAP_ROWS = [
  { key: 'design', name: 'Solution design & blueprinting', desc: 'Functional specs, process design, architecture' },
  { key: 'test', name: 'Testing', desc: 'Unit, integration, UAT, performance' },
  { key: 'migration', name: 'Data migration', desc: 'Extract, transform, load, reconciliation' },
  { key: 'cutover', name: 'Cutover & go-live', desc: 'Dress rehearsal, execution, hypercare start' },
  { key: 'training', name: 'Training', desc: 'End-user and train-the-trainer' },
  { key: 'pm', name: 'Programme management', desc: 'Governance, reporting, coordination' },
  { key: 'hypercare', name: 'Hypercare', desc: 'Post go-live stabilisation' },
];

export const RISK_ROWS = [
  { key: 'completeness', name: 'Requirements completeness', desc: 'How well requirements are defined before build' },
  { key: 'experience', name: 'Team experience', desc: 'Familiarity with platform and programme type' },
  { key: 'complexity', name: 'Technical complexity', desc: 'Integrations, custom dev, data volume' },
  { key: 'dataQuality', name: 'Data quality', desc: 'Legacy data cleanliness and mapping confidence' },
];

export function getOverride(overrides, key, fallback) {
  return overrides?.[key] !== undefined ? overrides[key] : fallback;
}

export function getExtrapOverride(overrides, key) {
  const k = `extrap_${key}`;
  return overrides?.[k] !== undefined ? overrides[k] : PLATFORM_ESTIMATION_DEFAULTS.extrap[key];
}
